export const PREVIEW_FOR = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile'
}